import { GrippUIAppProps } from './types';

const GrippUIApp = ({ children }: GrippUIAppProps): JSX.Element => {
    return (<> {children} </>)
};

export default GrippUIApp;